import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const NewSend: FC<ISvG> = ({ width = 16, height = 16, className }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.5 2.5L2.5 8.67647L8.67647 11.3235M17.5 2.5L11.3235 17.5L8.67647 11.3235M17.5 2.5L8.67647 11.3235"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(NewSend);
